export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  market:
    "https://images.unsplash.com/photo-1790955208838-12fb1886b0ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  directory:
    "https://images.unsplash.com/photo-1711097383282-28097ae16b1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  explainer:
    "https://images.unsplash.com/photo-1600132806370-bf17e65e942f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  press:
    "https://images.unsplash.com/photo-1651341050677-24dba59ce0fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  newsletter:
    "https://images.unsplash.com/photo-1673813497649-9b1ff22e6185?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Terminal image plate: gradient panel with a blended image; if the image
// fails to load the gradient panel alone carries the design.
export const TerminalImage = ({ src, alt, className = "", children, testId }) => (
  <div className={`relative overflow-hidden ${className}`} data-testid={testId}>
    <img
      src={src}
      alt={alt}
      loading="lazy"
      className="absolute inset-0 h-full w-full object-cover opacity-30"
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent" />
    <div className="relative z-10 h-full flex flex-col justify-between">{children}</div>
  </div>
);
